module.exports = __webpack_public_path__ + "static/media/ic-mais-vida-min.d68ccdd7.svg";